import React from "react";
import Layout from "../../components/Layout/Layout";
import "./Transaction.css";
import transaction from "../../assets/transaction.jpeg";

const Transaction: React.FC = () => {
    return (
        <Layout>
            <div className="transactionContainer">
                <h1 className="pageTitle">Transaction Immobilière</h1>

                <div className="contentPaper">
                    <p className="sectionTitle"><b>À la recherche de votre nouveau bien immobilier ?</b></p>
                    <p className="contentText">
                        La <b>vente d'un bien immobilier</b> est une étape importante, qu'il s'agisse d'un appartement,
                        d'une maison, d'un local commercial ou d'un terrain. Que vous soyez propriétaire occupant
                        ou investisseur, <b>vendre au bon prix et dans les meilleurs délais</b> est essentiel pour
                        concrétiser un nouveau projet.
                    </p>

                    <p className="sectionTitle">
                        <b>Confier la vente de votre logement à <span className="highlightBrand">AKTE IMMOBILIER</span>, c'est bénéficier :</b>
                    </p>
                    <ul className="benefitsList">
                        <li>D'une estimation immobilière en cohérence avec le marché local</li>
                        <li>D'une visibilité maximale grâce à nos canaux de diffusion et notre réseau de partenaires</li>
                        <li>D'un accompagnement personnalisé tout au long de votre projet</li>
                        <li>D'une négociation sécurisée et d'un suivi administratif rigoureux</li>
                    </ul>
                </div>
            </div>
        </Layout>
    );
};

export default Transaction;
